export const dummyBookings = [
  { startRow: 4, size: 10 },
  { startRow: 4, size: 10 },
  { startRow: 5, size: 6 },
  { startRow: 5, size: 6 },
  { startRow: 4, size: 6 },
  { startRow: 3, size: 6 },
  { startRow: 3, size: 6 },
  { startRow: 7, size: 2 },
  { startRow: 7, size: 2 },
]

const booking1 = [
  { col: 1, row: 3, size: 10 },
  { col: 2, row: 3, size: 10 },
  { col: 3, row: 4, size: 6 },
  { col: 4, row: 4, size: 6 },
  { col: 5, row: 4, size: 6 },
  { col: 6, row: 5, size: 4 },
  { col: 7, row: 5, size: 4 },
  { col: 8, row: 5, size: 4 },
  { col: 9, row: 7, size: 2 },
  { col: 10, row: 7, size: 2 },
  
  { col: 1, row: 17, size: 4 },
  { col: 2, row: 17, size: 4 },
  { col: 3, row: 17, size: 2 },
  { col: 4, row: 17, size: 2 },
  { col: 5, row: 17, size: 2 },
  { col: 6, row: 17, size: 2 },
  { col: 7, row: 17, size: 2 },
  { col: 8, row: 17, size: 2 },
  { col: 9, row: 17, size: 2 },
  { col: 10, row: 17, size: 1 },
]
const booking2 = [
  { col: 1, row: 14, size: 16 },
  { col: 2, row: 14, size: 16 },
  { col: 3, row: 18, size: 10 },
  { col: 4, row: 18, size: 10 },
  { col: 5, row: 18, size: 10 },
  { col: 6, row: 20, size: 6 },
  { col: 7, row: 20, size: 6 },
  { col: 8, row: 22, size: 4 },
  { col: 1, row: 30, size: 12 },
  { col: 2, row: 30, size: 12 },
  { col: 3, row: 30, size: 10 },
  { col: 4, row: 30, size: 10 },
  { col: 5, row: 30, size: 10 },
  { col: 6, row: 34, size: 6 },
  { col: 7, row: 34, size: 6 },
  { col: 8, row: 36, size: 4 },
]
const booking3 = [
  { col: 1, row: 10, size: 30 },
  { col: 2, row: 10, size: 30 },
  { col: 3, row: 10, size: 30 },
  { col: 4, row: 10, size: 30 },
  { col: 5, row: 10, size: 30 },
  { col: 6, row: 15, size: 10 },
  { col: 7, row: 15, size: 10 },
  { col: 8, row: 15, size: 10 },
  { col: 6, row: 30, size: 10 },
  { col: 7, row: 30, size: 10 },
  { col: 8, row: 30, size: 6 },
  { col: 9, row: 30, size: 6 },
  { col: 10, row: 30, size: 6 },
  { col: 11, row: 30, size: 6 },
  { col: 12, row: 30, size: 6 },
]


const booking4 = [
  { col: 1, row: 10, size: 12 },
  { col: 2, row: 10, size: 12 },
  { col: 1, row: 24, size: 18 },
  { col: 2, row: 30, size: 12 },
]



export const previousBookings = [
  booking1,
  booking2,
  booking3,
  booking4
]